import { PendingCounterState } from 'Models'

export const isLoadingSelector = (state: { pendingCounter: PendingCounterState }): boolean => !!state.pendingCounter
